<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <c-table
          ref="typegrid"
          title="평가구분"
          tableId="typegrid"
          :columns="typegrid.columns"
          :data="typegrid.data"
          :usePaging="false"
          :hideBottom="true"
          :editable="editable"
          :columnSetting="false"
          :isFullScreen="false"
          :filtering="false"
          :isExcelDown="false"
          selection="multiple"
          rowKey="vendorEvaluationTypeCd"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <c-btn label="" icon="add" @btnClicked="addrowType" v-if="editable" />
            <c-btn label="" icon="remove" @btnClicked="removeRowType" v-if="editable" />
            <c-btn label="" icon="save" @btnClicked="saveMstType" v-if="editable" />
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name === 'click'">
              <q-chip
                v-if="props.row.editFlag !== 'C'"
                color="blue"
                :clickable="true"
                :editable="editable"
                text-color="white"
                @click="rowClick(props.row)">
                ▶
              </q-chip>
            </template>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-search-box @enter="getTypeList">
          <template slot="search">
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <!-- 사업장 -->
              <c-plant type="edit" name="plantCd" :required="true" v-model="searchParam.plantCd" @input="getTypeList"/>
            </div>
          </template>
        </c-search-box>
        <c-table
          ref="itemgrid"
          title="평가항목"
          tableId="itemgrid"
          :columns="itemgrid.columns"
          :data="itemgrid.data"
          :usePaging="false"
          :hideBottom="true"
          :editable="editable"
          :columnSetting="false"
          selection="multiple"
          rowKey="mdmVendorEvaluationItemId"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="추가" icon="add" @btnClicked="addrow" v-if="editable && isSelectGrp" />
              <c-btn label="삭제" icon="remove" @btnClicked="removeRow" v-if="editable && isSelectGrp" />
              <c-btn label="저장" icon="save" @btnClicked="saveMst" v-if="editable && isSelectGrp" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'vendor-Assess-item',
  watch: {
    'searchParam.plantCd': function() {
      this.itemgrid.data = [];
      this.rowRemoveSelect();
    }
  },
  data() {
    return {
      editable: true,
      searchParam: {
        plantCd: null,
      },
      isSelectGrp: false,
      selectedGroupCd: '',
      listUrl1: '',
      saveUrl1: '',
      deleteUrl1: '',
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      typegrid: {
        columns: [
          {
            name: 'vendorEvaluationTypeNm',
            field: 'vendorEvaluationTypeNm',
            label: '평가구분',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            name: 'orderNo',
            field: 'orderNo',
            label: '정렬순서',
            align: 'center',
            type: 'text',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'click',
            field: 'click',
            label: '평가항목',
            align: 'center',
            style: 'width:70px',
            sortable: false,
            type: 'custom',
          },
        ],
        data: [],
      },
      itemgrid: {
        columns: [
          {
            name: 'itemNm',
            field: 'itemNm',
            label: '평가항목',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            name: 'evaluationCriteria',
            field: 'evaluationCriteria',
            label: '평가기준',
            align: 'left',
            type: 'text',
            style: 'width:50%',
            sortable: false,
          },
          {
            name: 'scoring',
            field: 'scoring',
            label: '배점',
            align: 'center',
            type: 'text',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'orderNo',
            field: 'orderNo',
            label: '정렬순서',
            align: 'center',
            type: 'text',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width:80px',
            sortable: false,
            type: 'check',
            true: 'Y',
            false: 'N'
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // url setting
      this.editable = this.$route.meta.editable;
      this.listUrl1 = selectConfig.mdm.cim.vendor.type.list.url;
      this.saveUrl1 = transactionConfig.mdm.cim.vendor.type.save.url;
      this.deleteUrl1 = transactionConfig.mdm.cim.vendor.type.delete.url;
      this.listUrl = selectConfig.mdm.cim.vendor.item.list.url;
      this.saveUrl = transactionConfig.mdm.cim.vendor.item.save.url;
      this.deleteUrl = transactionConfig.mdm.cim.vendor.item.delete.url;
      this.getTypeList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1');
      if (_table.length > 0) {
        for(let c = 0; c <= _table.length; c++) {
          _table[c].classList.remove('bg-light-blue-1');
        }
      }
      this.selectedGroupCd = '';
    },
    rowClick(row) {
      this.getItemList(row);
    },
    getTypeList() {
      this.rowRemoveSelect();
      this.isSelectGrp = false;
      this.itemgrid.data = [];
      if (this.searchParam.plantCd === null || this.searchParam.plantCd == '' ) {
        this.typegrid.data = [];
      } else {
        this.$http.url = this.listUrl1;
        this.$http.type = 'GET';
        this.$http.param = {}
        this.$http.request((_result) => {
          this.typegrid.data = _result.data;
        },
        () => {
        });
      }
    },
    getItemList(_row) {
      if (this.searchParam.plantCd.indexOf(',') < 0) {
        this.isSelectGrp = true;
        this.selectedGroupCd = _row.vendorEvaluationTypeCd;
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.searchParam.plantCd,
          vendorEvaluationTypeCd: _row.vendorEvaluationTypeCd,
        }
        this.$http.request((_result) => {
          this.itemgrid.data = _result.data;
        },
        () => {
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '사업장을 선택하세요',
          type: 'warning', // success / info / warning / error
        });
        this.itemgrid.data = [];
      }
    },
    addrow() {
      this.itemgrid.data.push({
        editFlag: 'C',
        plantCd: this.searchParam.plantCd,  // 사업장코드
        mdmVendorEvaluationItemId: uid(),  // 평가항목 일련번호
        vendorEvaluationTypeCd: this.selectedGroupCd,  // 평가항목 종류코드
        itemNm: '',  // 평가항목명
        scoring: '',  // 배점
        evaluationCriteria: '',  // 평가기준
        orderNo: (this.itemgrid.data.length + 1) * 10,  // 정렬순서
        useFlag: 'Y',  // 사용여부
      })
    },
    addrowType() {
      this.typegrid.data.push({
        editFlag: 'C',
        vendorEvaluationTypeCd: uid(),  // 평가항목 종류코드
        vendorEvaluationTypeNm: '',  // 평가항목 종류명
        orderNo: (this.typegrid.data.length + 1) * 10,  // 정렬순서
        useFlag: 'Y',  // 사용여부
      })
    },
    saveMst() {
      let checkItem = ['itemNm', 'scoring', 'orderNo']
      let isConti = true;
      this.$_.forEach(this.itemgrid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [평가항목, 배점, 정렬순서]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.itemgrid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                window.getApp.$emit('APP_REQUEST_SUCCESS');
                this.getItemList({vendorEvaluationTypeCd: saveData[0].vendorEvaluationTypeCd});
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    saveMstType() {
      let checkItem = ['vendorEvaluationTypeNm', 'orderNo']
      let isConti = true;
      this.$_.forEach(this.typegrid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [평가종류, 정렬순서]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.typegrid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl1;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                window.getApp.$emit('APP_REQUEST_SUCCESS');
                this.getTypeList();
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    removeRow() {
      let selectData = this.$refs['itemgrid'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요. typegrid
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getItemList({code: selectData[0].codeGrpCd});
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.itemgrid.data = this.$_.reject(this.itemgrid.data, item);
              })
              this.$refs['itemgrid'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    removeRowType() {
      let selectData = this.$refs['typegrid'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요. 
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl1);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getItemList({code: selectData[0].codeGrpCd});
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.typegrid.data = this.$_.reject(this.typegrid.data, item);
              })
              this.$refs['typegrid'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
